import { render } from "./recordDetail.vue?vue&type=template&id=6c137966&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"

import "./recordDetail.vue?vue&type=style&index=0&id=6c137966&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c137966"],['__file',"src/views/alfmeier/payment/recordDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c137966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c137966', __exports__)) {
    console.log('reload')
    api.reload('6c137966', __exports__)
  }
  
  module.hot.accept("./recordDetail.vue?vue&type=template&id=6c137966&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c137966', render)
  })

}


export default __exports__